<template>
    <div>
        <img class="bgImg" src="@/assets/default/one.png" alt="" />
        <div class="describe">无权限访问<el-link href="/" type="primary" style="margin-left: 20px;">返回</el-link></div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    methods: {

    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.bgImg{
    display: block;
    margin: 200px auto 30px;
}
.describe{
    text-align: center;
    font-size: 24px;
    color: #333333;
}
</style>